/** HH:MM com horas livres (ex.: 176:00). Minutos 00–59. */
export const CARGA_HHMM_REGEX = /^(\d{1,3}):([0-5]\d)$/

export const parseCargaHhMmToMinutes = (hhmm) => {
  const raw = String(hhmm || '').trim()
  const match = raw.match(CARGA_HHMM_REGEX)
  if (!match) return null
  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null
  return hours * 60 + minutes
}

export const validateCargaHhMm = (hhmm, maxHhmm) => {
  const minutes = parseCargaHhMmToMinutes(hhmm)
  if (minutes == null) {
    return 'Informe a carga no formato HH:MM (ex.: 88:00).'
  }
  const maxMinutes = parseCargaHhMmToMinutes(maxHhmm)
  if (maxMinutes == null) {
    return 'Carga contratual máxima inválida.'
  }
  if (minutes < 0) {
    return 'A carga não pode ser negativa.'
  }
  if (minutes > maxMinutes) {
    return `A carga não pode ser maior que ${maxHhmm} (contrato).`
  }
  return null
}
